export default "__VITE_ASSET__BNUVEViD__"